<template>
  <div>
    <Form
      style="margin: 30px 20px"
      :model="formItem"
      :label-width="120"
      label-position="left"
    >
      <Row>
        <Col span="6">
          <FormItem label="应聘职位:">
            <Input v-model="formItem.candidatePosition" :disabled="loading" />
          </FormItem>
        </Col>
        <Col span="6" offset="1">
          <FormItem label="申请单状态：">
            <!-- <Input v-model="formItem.beInitiateApplication" :disabled="loading" /> -->
            <Select
              v-model="formItem.beInitiateApplication"
              :disabled="loading"
              :clearable="true"
              placeholder=""
            >
              <Option :value="item.code" v-for="(item, i) in SQDZTList" :key="i"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="4" offset="1">
          <Button type="primary" @click="initgetData" :disabled="loading"
            ><!-- 检索 -->{{ $t("Search") }}</Button
          >
        </Col>
      </Row>
    </Form>
    <Card style="margin-top: 20px">
      <Table
        border
        ref="table"
        :loading="loading"
        :columns="OnboardinglColumns"
        :data="OnboardingData"
        width="100%"
        stripe
      >
        <template slot-scope="{ row, index }" slot="list">
          <Button
            type="primary"
            size="small"
            @click="OnboardingList(row, index)"
            >List</Button
          >
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Icon
            type="md-eye"
            color="#8CD29B"
            style="font-size: 26px;"
            @click="OnboardingOpen(row, index)"
          />
        </template>
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>

    <!-- Onboarding List画面 -->
    <Modal
      v-model="showOnboardingList"
      width="80%"
      :footer-hide="true"
      title="入职列表"
      :styles="{ top: '20px' }"
    >
      <div style="padding: 0px 25px">
        <FormTitle titleText="入职信息" />
        <Form
          :label-width="labelPosition == 'left' ? 360 : null"
          :label-position="labelPosition"
          :disabled="prevent"
          style="margin-top:20px"
          class="onboardingModal"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                label="应聘者姓名"
                :label-width="labelPosition == 'left' ? 100 : null"
              >
                <Input v-model="onboardingList.userName" :disabled="true" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                label="私人邮箱"
                :label-width="labelPosition == 'left' ? 100 : null"
              >
                <Input v-model="onboardingList.mail" :disabled="true" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                label="雇佣日"
                :label-width="labelPosition == 'left' ? 100 : null"
              >
                <Date-picker
                  type="date"
                  style="width: 100%"
                  v-model="onboardingList.hire_date"
                  :disabled="true"
                ></Date-picker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="员工完成My Hire个人信息填写">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="
                      onboardingList.onboardingListCandidateCompleteNewHireForm
                    "
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListCandidateCompleteNewHireFormInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="HRBP/MA 在My Hire中完成数据填写">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="
                      onboardingList.onboardingListHrbpMaCompleteNewHireForm
                    "
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListHrbpMaCompleteNewHireFormInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="准备入职材料">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="
                      onboardingList.onboardingListPrepareOnboardingPackage
                    "
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListPrepareOnboardingPackageInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <ul>
            <li
              v-for="(item, i) in entityList"
              :key="i"
              style="line-height:2em;margin-left:12px"
            >
              {{ item.task_word }}
              <!-- <Button 
              v-if="item.task_word == '劳动合同'"
              class="applyBtnRight"
              style="margin-left: 30%;"
              @click="exportContract"
              >导出合同</Button> -->
            </li>
          </ul>
          <Row>
            <Col span="24">
              <FormItem label="行政工位/名牌/文具准备（如有）">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="
                      onboardingList.onboardingListStationaryPreparedByAdminIfNeeded
                    "
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListStationaryPreparedByAdminIfNeededInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="收到离职证明扫描件">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="
                      onboardingList.onboardingListReceiveScanningCopyOfExitCertificate
                    "
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListReceiveScanningCopyOfExitCertificateInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="轨迹证明/健康码（如需）">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="onboardingList.onboardingListHealthCodeIfNeeded"
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListHealthCodeIfNeededInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="报岗">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="
                      onboardingList.onboardingListSocialBenefitsRegistration
                    "
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListSocialBenefitsRegistrationInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="P-file归档">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="onboardingList.onboardingListCompletePFiling"
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="onboardingList.onboardingListCompletePFilingInput"
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="参加入司首日介绍会">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="onboardingList.onboardingListAttendDayIntroduction"
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="
                      onboardingList.onboardingListAttendDayIntroductionInput
                    "
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="参加NEO">
                <div style="display:flex">
                  <i-switch
                    class="switchStyle"
                    v-model="onboardingList.onboardingListAttendNeo"
                    size="small"
                  ></i-switch>
                  <Input
                    style="display:inline;width:100%"
                    v-model="onboardingList.onboardingListAttendNeoInput"
                  ></Input>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="NEO测试分数">
                <Input v-model="onboardingList.onboardingListNeoTestScore" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注">
                <Input
                  type="textarea"
                  v-model="onboardingList.onboardingListOtherRemarks"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <Row class="btnRight">
        <Col>
          <Button class="approvalBtnRight" @click="onboardingListhandle"
            >保存</Button
          >
          <Button
            class="approvalBtnRight"
            @click="modelCancel"
            style="margin-left:60px"
            >返回</Button
          >
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      showInternational: false,
      loading: false,
      plan: "",
      formItem: {},
      SQDZTList: [],
      pageInfo: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      OnboardinglColumns: [
        {
          title: "申请单号",
          key: "applyNo",
          align: "center",
          width: "200"
        },
        {
          title: "申请单状态",
          key: "status",
          align: "center",
          width: "140",
          render: (h, params) => {
            return h(
              "span",
              this.SQDZTList &&
                this.SQDZTList.filter(
                  item => params.row.status == item.code
                ).map(res => res.name)
            );
          }
        },
        {
          title: "申请日",
          key: "createTime",
          align: "center",
          width: "150",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.createTime, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "应聘职位",
          key: "candidatePosition",
          align: "center",
          width: "180"
        },
        {
          title: "中文姓名",
          key: "userName",
          align: "center",
          width: "130"
        },
        {
          title: "性别",
          key: "gender",
          width: 120,
          align: "center"
        },
        {
          title: "年龄",
          key: "age",
          width: 120,
          align: "center"
        },
        {
          title: "身份证号码",
          key: "nationalIdNumber",
          width: 230,
          align: "center"
        },
        {
          title: "个人邮件地址",
          width: 230,
          key: "mail",
          align: "center"
        },
        {
          title: "手机",
          width: 140,
          key: "mobilePersonal",
          align: "center"
        },
        {
          title: "入职列表",
          slot: "list",
          width: 100,
          fixed: "right",
          align: "center"
        },
        {
          title: "查看",
          slot: "action",
          width: 100,
          fixed: "right",
          align: "center"
        }
      ],
      OnboardingData: [],
      showFormItem: {},
      beUsed: null,
      showOnboardingList: false,
      onboardingList: {},
      entityList: [],
      labelPosition: "left",
      prevent: false
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        if (window.innerWidth < 1140) {
          this.labelPosition = "top";
        } else {
          this.labelPosition = "left";
        }
      });
    });
  },
  created() {
    this.initgetData();
  },
  methods: {
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.initgetData();
    },
    initgetData() {
      let obj = {
        candidatePosition: this.formItem.candidatePosition,
        status: this.formItem.beInitiateApplication,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      axios.post("ApplyOnboarding/selectApplyOnboardingList", obj).then(res => {
        this.loading = false;
        if (res) {
          this.OnboardingData = res.data;
          this.SQDZTList = res.optionData.status;
          this.total = Number(res.pageInfo.total);
        }
      });
    },
    OnboardingOpen(row, index) {
      this.$router.push(
        "/EA05DA2E97A25C31821CD79CAA80E373E15B198FEB9C9B43/A3FFBEBFDB713E27?instanceId=" +
          row.instanceId +
          "&isProcessList=true"
      );
    },
    OnboardingList(row, index) {
      this.prevent = true;
      axios
        .post("/ApplyOnboarding/selectOnboardListInfo", {
          instanceId: row.instanceId
        })
        .then(res => {
          this.prevent = false;
          if (res) {
            this.onboardingList = res;
            this.onboardingList.onboardingListCandidateCompleteNewHireForm
              ? (this.onboardingList.onboardingListCandidateCompleteNewHireForm = !!+this
                  .onboardingList.onboardingListCandidateCompleteNewHireForm)
              : "";
            this.onboardingList.onboardingListHrbpMaCompleteNewHireForm
              ? (this.onboardingList.onboardingListHrbpMaCompleteNewHireForm = !!+this
                  .onboardingList.onboardingListHrbpMaCompleteNewHireForm)
              : "";
            this.onboardingList.onboardingListPrepareOnboardingPackage
              ? (this.onboardingList.onboardingListPrepareOnboardingPackage = !!+this
                  .onboardingList.onboardingListPrepareOnboardingPackage)
              : "";
            this.onboardingList.onboardingListStationaryPreparedByAdminIfNeeded
              ? (this.onboardingList.onboardingListStationaryPreparedByAdminIfNeeded = !!+this
                  .onboardingList
                  .onboardingListStationaryPreparedByAdminIfNeeded)
              : "";
            this.onboardingList
              .onboardingListReceiveScanningCopyOfExitCertificate
              ? (this.onboardingList.onboardingListReceiveScanningCopyOfExitCertificate = !!+this
                  .onboardingList
                  .onboardingListReceiveScanningCopyOfExitCertificate)
              : "";
            this.onboardingList.onboardingListHealthCodeIfNeeded
              ? (this.onboardingList.onboardingListHealthCodeIfNeeded = !!+this
                  .onboardingList.onboardingListHealthCodeIfNeeded)
              : "";
            this.onboardingList.onboardingListSocialBenefitsRegistration
              ? (this.onboardingList.onboardingListSocialBenefitsRegistration = !!+this
                  .onboardingList.onboardingListSocialBenefitsRegistration)
              : "";
            this.onboardingList.onboardingListCompletePFiling
              ? (this.onboardingList.onboardingListCompletePFiling = !!+this
                  .onboardingList.onboardingListCompletePFiling)
              : "";
            this.onboardingList.onboardingListAttendDayIntroduction
              ? (this.onboardingList.onboardingListAttendDayIntroduction = !!+this
                  .onboardingList.onboardingListAttendDayIntroduction)
              : "";
            this.onboardingList.onboardingListAttendNeo
              ? (this.onboardingList.onboardingListAttendNeo = !!+this
                  .onboardingList.onboardingListAttendNeo)
              : "";
            this.entityList = res.entityList;
          }
        });
      this.showOnboardingList = true;
    },
    exportContract() {
      this.$donwLoad();
    },
    onboardingListhandle() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        onOk: () => {
          let obj = {
            ...this.onboardingList
          };
          this.prevent = true;
          axios
            .post("/ApplyOnboarding/updateOnboardListInfo", obj)
            .then(res => {
              this.prevent = false;
              if (res) {
                this.$Message.info(this.$("sbumit_Success"));
                this.showOnboardingList = false;
              }
            });
        }
      });
    },
    modelCancel() {
      this.showOnboardingList = false;
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}

@media screen and (max-width: 640px) {
  .formCol {
    width: 100%;
    margin-right: 0px;
  }

  .photoava {
    margin-top: 0px;
  }
}

.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.ivu-date-picker {
  width: 100%;
}
.switchStyle {
  width: 35px;
  margin: 8px 50px 0 50px;
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .switchStyle {
    margin: 8px 50px 0 0px;
  }
}
@media screen and (max-width: 800px) {
  .switchStyle {
    margin: 8px 50px 0 0px;
  }
}
.onboardingModal {
  height: calc(100vh - 260px);
  overflow-y: auto;
}
.btnRight {
  margin-top: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyManagement/InductionProcess.vue